import { useCallback } from 'react';
import { useA11yStore } from '../store/a11yStore';

/**
 * Speak a message through the app's shared live regions.
 *
 *   const announce = useAnnounce();
 *   announce(t('board.yourTurn'), 'assertive');
 *
 * Prefer 'polite' (the default). 'assertive' cuts off whatever the screen reader is currently
 * saying, so it is for things the player must not miss: their turn starting, a failure, a lost
 * connection. Using it for ordinary status makes the game unreadable.
 */
export function useAnnounce() {
  const announce = useA11yStore((s) => s.announce);
  return useCallback(
    (message: string, urgency: 'polite' | 'assertive' = 'polite') => announce(message, urgency),
    [announce]
  );
}
